import React from 'react';
import PropTypes from 'prop-types';
import styles from './StatusCircle.module.css';
import { ReactComponent as CheckIcon } from '../../../Assets/icons/toastIcon/successIcon.svg';
import { ReactComponent as CicleIcon } from '../../../Assets/icons/circle.svg';

export default function StatusCircle({ isChecked = false }) {
  return (
    <div className={styles.statusCircle}>
      {isChecked ? <CheckIcon /> : <CicleIcon />}
    </div>
  );
}

StatusCircle.propTypes = {
  isChecked: PropTypes.bool,
};
